import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca396dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-mainframe" }
const _hoisted_2 = {
  key: 0,
  class: "firefox-popup-address is-family-monospace"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "main-toaster pb-4"
}

import { useRouter } from 'vue-router'
import { ref, computed, onMounted, toRaw } from 'vue'

import NavbarMain from '@/popup/components/frames/Main/NavbarMain/NavbarMain.vue'
import Toaster from '@/popup/components/shared/Toaster.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'
import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { truncateMiddle } from '@/shared/utils'
import { useAppStore } from '@/popup/store/AppStore'
import {
  fetchLatestProfile,
  loadCachedPopupProfile,
} from '@/popup/utils/profiles'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainFrame',
  setup(__props) {

const router = useRouter()
const appStore = useAppStore()
const uiStore = useUIStore()
const dropdownIsOpen = ref(false)

const currentRouteName = computed(() => router.currentRoute.value.name)

const isNotificationRoute = computed(
  () =>
    currentRouteName.value === 'home' ||
    currentRouteName.value === 'edit-profile' ||
    currentRouteName.value === 'expanded'
)

const isModalRoute = computed(() => currentRouteName.value === 'settings')
const toast = computed(() => uiStore.toast)

const handleChangeDropdown = (state: boolean) => {
  dropdownIsOpen.value = state
}

onMounted(async () => {
  if (appStore.selectedProfile) {
    try {
      const profile = await loadCachedPopupProfile(appStore.selectedProfile)
      if (
        !profile?.saved?.name ||
        (Array.isArray(profile?.saved?.profileImage) &&
          profile?.saved?.profileImage.length === 0)
      ) {
        const fetchedProfile = await fetchLatestProfile({
          address: appStore.selectedProfile,
        })
        await appStore.savePopupProfile(
          toRaw({ ...fetchedProfile, address: appStore.selectedProfile })
        )
      }
    } catch {}
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(AppIdenticon),
      (_unref(uiStore).isExternalPopup)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(appStore).currentProfile.name ||
        _unref(truncateMiddle)(_unref(appStore).currentProfile.address, 8)), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(NavbarMain, {
              "dropdown-is-open": dropdownIsOpen.value,
              "handle-change-dropdown": handleChangeDropdown,
              "is-modal-route": isModalRoute.value
            }, null, 8 /* PROPS */, ["dropdown-is-open", "is-modal-route"])
          ])),
      _createElementVNode("div", {
        class: _normalizeClass(`content ${isModalRoute.value ? 'content-background' : ''}
      `)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(dropdownIsOpen.value ? 'backdrop' : ''),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeDropdown(false)))
        }, null, 2 /* CLASS */),
        _createVNode(_Transition, {
          name: "slide",
          onAfterLeave: _cache[1] || (_cache[1] = ($event: any) => (_unref(uiStore).setScrollRefresh()))
        }, {
          default: _withCtx(() => [
            (toast.value && isNotificationRoute.value && !_unref(uiStore).isExternalPopup)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(Toaster, {
                    message: toast.value.message,
                    "message-icon": toast.value.icon,
                    background: toast.value.background,
                    id: toast.value.id,
                    path: toast.value.path
                  }, null, 8 /* PROPS */, ["message", "message-icon", "background", "id", "path"])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_router_view)
      ], 2 /* CLASS */)
    ]),
    _createVNode(NetworkSwitchWrapper)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})